<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">Record Search</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="searchForm">
          <div class="row mt-1">
            <label for="company" class="col-4 col-form-label">Company</label>
            <div class="col-8">
              <input id="company" type="text" class="form-control" formControlName="company" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="first" class="col-4 col-form-label">First</label>
            <div class="col-8">
              <input id="first" type="text" class="form-control" formControlName="first" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="last" class="col-4 col-form-label">Last</label>
            <div class="col-8">
              <input id="last" type="text" class="form-control" formControlName="last" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1" *ngIf="vm.options?.includeAddress">
            <label for="suburb" class="col-4 col-form-label">Address</label>
            <div class="col-8">
              <input id="address1" type="text" class="form-control" formControlName="address1" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="suburb" class="col-4 col-form-label">Suburb</label>
            <div class="col-8">
              <input id="suburb" type="text" class="form-control" formControlName="suburb" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="phone" class="col-4 col-form-label">Phone #</label>
            <div class="col-4">
              <input id="phone" type="text" class="form-control" formControlName="phone" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="postcode" class="col-4 col-form-label">Postcode</label>
            <div class="col-2">
              <input id="postcode" type="text" class="form-control" formControlName="postcode" autocomplete="off"
                aria-autocomplete="list" />
            </div>
          </div>
          <div class="row mt-1" *ngFor="let crit of vm.searchCriteria">
            <label for="fieldName" class="col-4 col-form-label">{{
              crit.description
              }}</label>
            <div class="col-6">
              <input *ngIf="crit.name !== 'u2'" id="fieldName" type="text" class="form-control"
                [formControlName]="crit.name" autocomplete="off" aria-autocomplete="list" />
              <input *ngIf="crit.name === 'u2'" id="fieldName" type="date" class="form-control"
                [formControlName]="crit.name" autocomplete="off" aria-autocomplete="list" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-12 mt-2">
      <div class="row justify-content-end">
        <div>
          <button type="button" class="btn btn-secondary mx-1" (click)="search()">
            Search
          </button>
          <button type="button" class="btn btn-secondary mx-1" *ngIf="vm.options?.showNew" (click)="newRecord()">
            New Record
          </button>
        </div>
      </div>
    </div>

    <table class="table mt-1 table-hover table-sm">
      <thead *ngIf="vm.loading !== undefined">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Phone</th>
          <th scope="col">Address</th>
          <th scope="col">Suburb</th>
          <th scope="col">State</th>
          <th scope="col">Postcode</th>
          <th *ngFor="let crit of vm.searchCriteria">
            {{ crit.description }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="vm.loading">
          <td [attr.colspan]="6 + (vm.searchCriteria?.length || 0)">
            Searching...
            <small class="float-right">Timeout in {{ vm.timeout }} seconds</small>
          </td>
        </tr>
        <tr *ngIf="vm.loading === false && !vm.results">
          <td [attr.colspan]="6 + (vm.searchCriteria?.length || 0)">
            Search timed out, please try again...
          </td>
        </tr>
        <tr *ngIf="vm.loading === false && vm.results && vm.results.length === 0">
          <td [attr.colspan]="6 + (vm.searchCriteria?.length || 0)">
            No Records Found...
          </td>
        </tr>
        <ng-container *ngIf="vm.loading === false && vm.results && vm.results.length > 0">
          <tr *ngFor="let r of vm.results" (click)="selectRecord(r.recordId)" class="cursor-pointer">
            <td>{{ r.sal }} {{ r.first }} {{ r.last }}</td>
            <td>{{ r.mobile || r.phone1 || r.phone2 || "&nbsp;" }}</td>
            <td>{{ r.address1 }}</td>
            <td>{{ r.suburb }}</td>
            <td>{{ r.state }}</td>
            <td>{{ r.postcode }}</td>
            <td *ngFor="let crit of vm.searchCriteria">
              {{
              crit.name === "u2"
              ? (r[crit.name] | date: "dd/MM/yyyy")
              : r[crit.name]
              }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-container>